const SITES = 'sites';
const SNAP_QUOTES = 'snap-quotes';

export function param(s: string): string {
  return encodeURIComponent(s);
}

export const buildSiteUrl = (siteCode: string, path?: string) => {
  const base = `${SITES}/${siteCode}`;

  if (!path) {
    return base;
  }

  return `${base}/${path}`;
};

export const buildSnapQuoteUrl = (
  siteCode: string,
  uuid: string,
  path?: string,
) => {
  const base = buildSiteUrl(siteCode, `${SNAP_QUOTES}/${uuid}`);

  if (!path) {
    return base;
  }

  return `${base}/${path}`;
};

export const buildV2SiteUrl = (siteCode: string, path?: string) => {
  return `/v2/${buildSiteUrl(siteCode, path)}`;
};

export const buildV2Url = (path: string) => {
  return `/v2/${path}`;
};
